export default "__VITE_ASSET__BQ57sIA6__"